export default __webpack_public_path__ + "3310e3301abe929ed359904e41ef3e5a.png";